import React from 'react';
import { Download, Printer } from 'lucide-react';
import Button from '../../../components/ui/Button';

const PrintDownloadActions = ({ policyData }) => {
  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const content = `
Privacy Policy
${policyData?.company || 'Company Name'}
Effective Date: ${policyData?.effectiveDate || 'N/A'}
Last Updated: ${policyData?.lastUpdated || 'N/A'}

${policyData?.sections?.map(section => `
${section?.title}
${section?.content}
`)?.join('\n') || 'No content available'}

Contact Information:
For privacy questions or requests, contact:
📧 support@skillbinder.com
📬 Epoxy Dogs LLC, 5698 Lamplighter Dr., Girard, OH 44420
    `?.trim();

    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL?.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${policyData?.service || 'SkillBinder'}_Privacy_Policy.txt`;
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
    window.URL?.revokeObjectURL(url);
  };

  return (
    <div className="flex items-center space-x-2">
      <Button
        onClick={handlePrint}
        variant="outline"
        size="sm"
        className="flex items-center space-x-2"
      >
        <Printer size={16} />
        <span className="hidden sm:inline">Print</span>
      </Button>
      
      <Button
        onClick={handleDownload}
        variant="outline"
        size="sm"
        className="flex items-center space-x-2"
      >
        <Download size={16} />
        <span className="hidden sm:inline">Download</span>
      </Button>
    </div>
  );
};

export default PrintDownloadActions;